module.exports = "<ck-editor #ckeditor name=\"name\" [(ngModel)]=\"value\" skin=\"moono-lisa\" language=\"en\" fullPage=\"fullpage\"></ck-editor>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixs-ckeditor/ixs-ckeditor.component.html
// module id = 1200
// module chunks = 320